import { ERD, SshCategoryActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  SSH_CATEGORY_ENDPOINTS_URLS,
  SSH_CATEGORY_TAGS,
} from "./api-ssh-category.constant";

export const {
  useCreateSshCategoryMutation,
  useReadManySshCategoriesQuery,
  useReadAvailableSshCategoriesQuery,
  useUpdateSshCategoryMutation,
  useDeleteSshCategoryMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createSshCategory: builder.mutation<
      ERD<SshCategoryActions["create"]>,
      QueryArgsNew<SshCategoryActions["create"]>
    >({
      query: ({ payload }) => ({
        url: SSH_CATEGORY_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [SSH_CATEGORY_TAGS.sshCategory],
    }),
    readManySshCategories: builder.query<
      ERD<SshCategoryActions["readMany"]>,
      QueryArgsNew<SshCategoryActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: SSH_CATEGORY_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [SSH_CATEGORY_TAGS.sshCategory],
    }),
    readAvailableSshCategories: builder.query<
      ERD<SshCategoryActions["readAvailable"]>,
      QueryArgsNew<SshCategoryActions["readAvailable"]>
    >({
      query: () => ({
        url: SSH_CATEGORY_ENDPOINTS_URLS.readAvailable,
        method: "get",
      }),
      providesTags: [SSH_CATEGORY_TAGS.sshCategory],
    }),
    updateSshCategory: builder.mutation<
      void,
      QueryArgsNew<SshCategoryActions["update"]>
    >({
      query: ({ payload, params }) => ({
        url: SSH_CATEGORY_ENDPOINTS_URLS.update(params),
        method: "put",
        payload,
      }),
      invalidatesTags: [SSH_CATEGORY_TAGS.sshCategory],
    }),
    deleteSshCategory: builder.mutation<
      void,
      QueryArgsNew<SshCategoryActions["delete"]>
    >({
      query: ({ params }) => ({
        url: SSH_CATEGORY_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [SSH_CATEGORY_TAGS.sshCategory],
    }),
  }),
});
